import { render, staticRenderFns } from "./subscription_payments.vue?vue&type=template&id=3145ed57&scoped=true"
import script from "./subscription_payments.vue?vue&type=script&lang=js"
export * from "./subscription_payments.vue?vue&type=script&lang=js"
import style0 from "./subscription_payments.vue?vue&type=style&index=0&id=3145ed57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145ed57",
  null
  
)

export default component.exports